import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

function ConformeModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="max-w-[500px] bg-white m-auto sm:rounded-2xl p-6 text-sm">
        <div className="flex justify-end mb-3">
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="max-h-[calc(100vh-84px)] sm:max-h-[calc(100vh-115px)] overflow-auto">
          <p className="text-center font-semibold mb-3">CONFORME</p>
          <p className="text-justify mb-3">
            I confirm that I have read, understood and agreed to be bound to
            the&nbsp;{/* */}
            <span className="font-semi-bold">
              {/* */}
              MAXICARE HEALTHCARE CORPORATION (“Maxicare”)
            </span>
            {/* */}
            &nbsp; Member Terms and Conditions which may be found at:
            Maxicare&nbsp;
            <a
              href="https://maxicare.ph/MaxicareeHealth"
              target="_blank"
              className="text-[#0869cf]"
              rel="noopener noreferrer"
            >
              eHealth Terms and Conditions
            </a>
            {/* */}.
          </p>
          <p className="text-justify">
            I further agree that any availment under my healthcare coverage with
            Maxicare may be denied under any of the following circumstances:
          </p>
          <ol className="list-decimal mb-3 pl-6">
            <li className="mb-2">
              Concealment, whether intentional or not, of relevant medical
              information, regardless of intent or relevance to the current
              availment;
            </li>
            <li className="mb-2">
              The availed treatment or procedure is not related to the illness
              for which this document was issued;
            </li>
            <li className="mb-2">
              It has been determined that the requested treatment or procedure
              is not medically necessary; and/or
            </li>
            <li>
              The requested treatment or procedure is excluded from my
              healthcare coverage and/or benefit plan.
            </li>
          </ol>
          <p className="text-justify mb-3">
            Moreover, I understand, confirm and agree that Maxicare is not
            responsible for the payment of the following charges and expenses:
          </p>
          <ol className="list-decimal mb-3 pl-6">
            <li className="mb-2">
              Medical services rendered by non-affiliated physicians and medical
              providers, except in cases of medical emergencies;
            </li>
            <li className="mb-2">
              Availments without prior authorization of Maxicare, even if
              conditionally approved by Maxicare;
            </li>
            <li className="mb-2">
              Amounts in excess and/or miscellaneous items outside the
              healthcare coverage and/or benefit plan, including professional
              fees of attending doctors in excess of the allowable limit
              regardless of any prior agreement with the said doctors;
            </li>
            <li className="mb-2">
              Upgrade of room accommodation beyond my healthcare coverage and/or
              benefit plan;
            </li>
            <li className="mb-2">Amounts covered by Philhealth;</li>
            <li className="mb-2">
              Personal preference to prolong confinement beyond the Attending
              Physician’s prescribed duration for hospitalization; and
            </li>
            <li>Any expense analogous to the foregoing.</li>
          </ol>
          <p className="text-justify mb-5">
            I likewise understand that Maxicare reserves the right to the final
            adjudication of my coverage based on the total remaining balance of
            my benefit limit.
          </p>
          <p className="text-center font-semibold mb-3">DATA PRIVACY CONSENT</p>
          <p className="text-justify mb-3">
            In connection with my availment and healthcare coverage, pursuant to
            the Service Agreement executed between Maxicare, myself, my employer
            and/or any entity sponsoring my healthcare coverage (“Agreement”) as
            may be applicable, I hereby freely, knowingly and voluntarily give
            my consent, in accordance with the applicable data privacy laws to
            Maxicare, its service providers, its agents, my employer and/or
            entity sponsoring my healthcare coverage with Maxicare, and/or its
            broker to:
          </p>
          <ol className="list-decimal mb-3 pl-6">
            <li className="mb-2">
              Collect, process and store my Personal Information relative to my
              membership with Maxicare, availment of any medical services,
              hospitalization, consultation, and treatment or any medical advice
              in connection with the benefit/claim availed under the Agreement,
              as may be deemed necessary by Maxicare. Except as otherwise stated
              in this Conforme, any Personal Information obtained relative to
              the authority herein given shall be kept strictly confidential.
              The extent of the processing of Personal Information shall be
              limited to what is necessary, appropriate or incidental to the
              performance of the services under the Agreement; and
            </li>
            <li>
              Disclose such Personal Information to Maxicare’s service
              providers, agents, my employer and/or entity sponsoring my
              healthcare coverage with Maxicare, and its broker, as well as
              relevant government agencies in compliance with applicable laws,
              rules and regulations, and for any legitimate business purpose as
              Maxicare may deem appropriate, including but not limited to
              outsourced processing of Maxicare transactions, disclosure to and
              transacting with lifestyle and rewards partners/providers,
              profiling or historical statistical analysis, providing advice or
              information which Maxicare believe may be of interest to me,
              administering or managing my accounts, enhancing customer
              services, or communicating with me for any marketing purposes.
            </li>
          </ol>
          <p className="text-justify mb-3">
            Personal Information include personal information, sensitive
            personal information and privileged information as defined in the
            applicable data privacy laws.
          </p>
          <p className="text-justify mb-3">
            I acknowledge and understand that the processing contemplated herein
            shall be without prejudice to, and shall at all times take into
            account and uphold my rights as a data subject, as provided under
            the data privacy laws, such as but not limited to the right to be
            informed, to object, access, complain, and rectify, to request for
            filtering of certain information, and to the corresponding damages
            in case of violation of your rights subject to the limitations as
            set forth in the data privacy laws.
          </p>
        </div>
      </div>
    </Modal>
  );
}

ConformeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConformeModal;
